export class DashboardRequest {
    placardId: string = '';
    username: string = '';
    cookie: string = '';
}